import { createContext } from "react";

export const UserContext = createContext(null);
export const MenuContext = createContext(false);
export const TransactionsDataContext = createContext([]);
